import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const FormatoEvaluacion = () => {
   const [formatoEvaluacion, setFormatoEvaluacion] = useState('');
  const { setPromptData, promptData } = useActividadesContext();

  const formatoValue = promptData?.formato ?? "";

  const handleFormatoEvaluacion = (event) => {
    const selectedFormatoEvaluacion = event.target.value;
    setFormatoEvaluacion(selectedFormatoEvaluacion);
    console.log("handleFormatoEvaluacion", { promptData });
    setPromptData((prevData) => ({
      ...prevData,
      formato: selectedFormatoEvaluacion,
    }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={3}>
      <Box>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography
            sx={{
              fontFamily: "montserrat",
              fontSize: "1.25rem",
              fontWeight: "bold",
              color: "#336B87",
            }}
          >
            Formato *
          </Typography>
        </Box>
        <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
          Selecciona el formato de la evaluación
        </FormLabel>
        <Grid sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="niveles de desempeño"
              name="formato_evaluacion"
              value={formatoValue}
              onChange={handleFormatoEvaluacion}
            >
              <FormControlLabel
                value="Escala de Likert"
                control={<Radio sx={{ color: "#336B87" }} />}
                label={
                  <Typography
                    sx={{
                      fontFamily: "montserrat",
                      fontSize: "0.8rem",
                      color: "#336B87",
                    }}
                  >
                    Escala de Likert
                  </Typography>
                }
              />
              <FormControlLabel
                value="Dinámicas cortas"
                control={<Radio sx={{ color: "#336B87" }} />}
                label={
                  <Typography
                    sx={{
                      fontFamily: "montserrat",
                      fontSize: "0.8rem",
                      color: "#336B87",
                    }}
                  >
                    Dinámicas cortas
                  </Typography>
                }
              />
              <FormControlLabel
                value="Rúbrica"
                control={<Radio sx={{ color: "#336B87" }} />}
                label={
                  <Typography
                    sx={{
                      fontFamily: "montserrat",
                      fontSize: "0.8rem",
                      color: "#336B87",
                    }}
                  >
                    Rúbrica
                  </Typography>
                }
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Box>
    </Grid>
  );
};

export default FormatoEvaluacion;
